import { RECEIVE_BOARD_DETAILS } from "../../../modules/savedItems/constants";

const receiveBoardDetails =
  ({ id: boardId, name: boardTitleText, itemCountMismatch }) =>
  async dispatch => {
    dispatch({
      type: RECEIVE_BOARD_DETAILS,
      payload: { boardId, boardTitleText, itemCountMismatch }
    });
  };

export default receiveBoardDetails;
